import { render, staticRenderFns } from "./compile-tab.vue?vue&type=template&id=58b3afd5"
import script from "./compile-tab.vue?vue&type=script&lang=js"
export * from "./compile-tab.vue?vue&type=script&lang=js"
import style0 from "./compile-tab.vue?vue&type=style&index=0&id=58b3afd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports